module.exports = __webpack_public_path__ + "img/item2.b759810d.png";